import WebApp from '@twa-dev/sdk'
import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'
import { goToMain, goToOnboarding, goToUpdating } from '@/app/routing/events'
import { $isUserLoading, $tgAccuntData, $userSettings, $userToken, getUserProfileFx } from '@/entities/user'
import { getSteamAuthUrlFx, authUserFx } from '@/entities/user'
import { LoadingScreen } from '@/shared/ui/loadingScreen'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { getAppStatusFx } from '@/entities/integration/model/effects'
import { $isAppUpdating } from '@/entities/integration/model/store'

export const StartPage = () => {
  useHideNav()
  const initData = WebApp.initData
  const isLoading = useUnit($isUserLoading)
  const userToken = useUnit($userToken)
  const userData = useUnit($tgAccuntData)
  const settings = useUnit($userSettings)
  const isAppUpdating = useUnit($isAppUpdating)
  const [isSettingsLoading, setIsSettingsLoading] = useState(true)
  const [isStatusLoading, setIsStatusLoading] = useState(true)

  useEffect(() => {
    if (initData) {
      authUserFx({
        init_data: initData,
      })
    }
  }, [initData])

  useEffect(() => {
    if (userToken) {
      getSteamAuthUrlFx(userToken)
      getUserProfileFx(userToken).finally(() => setIsSettingsLoading(false))
      getAppStatusFx(userToken).finally(() => setIsStatusLoading(false))
    }
  }, [userToken])

  useEffect(() => {
    if (isLoading || isSettingsLoading || isStatusLoading) {
      return
    } else if (isAppUpdating) {
      goToUpdating()
    } else if (!settings.isOnboarded) {
      return goToOnboarding()
    } else if (userData && userData.user.steam_id && !isLoading && settings) {
      return goToMain()
    } else {
      return goToMain()
    }
  }, [isLoading, userData, settings, isSettingsLoading, isStatusLoading, isAppUpdating])

  return <LoadingScreen visible />
}
